export default {
      id: "ic_uv2-usage",
      viewBox: "0 0 36 22",
      url: "/" + "images/icons.3.109.2.svg#ic_uv2-usage",
      toString: function () {
        return this.url;
      }
    }